module.exports = __webpack_public_path__ + "img/mark.a2f5011d.png";